export class GroupTicketProperties {
    groupId: number = 0;
    totalBaseFare: number = 0;
    totalTaxesAndOtherCharges: number = 0;
    ticketExpiryDate: Date;
    departureDate: Date;
    returnDate: Date;
    tripType: string;
    tripRoute: string;
    providerCode: string;
    supplierCode: string;
    officeId: string;
    onewayFromAirport: string;
    onewayToAirport: string;
    returnFromAirport: string;
    returnToAirport: string;
    totalNumberTicket: number;
    remainingTickets: number = 0;
    groupTicketTitle: string;
    groupTicketTitleId: number = 0;
    totalNetPrice: number = 0;
    totalGrossPrice: number = 0;
    groupTicketPNR: string;
    ticketCurrency: string;
    fareRulesDetails: string;
    generalRules: string;
    supplierRemarks: string;
    isAdult: boolean = false;
    isChild: boolean = false;
    isInfant: boolean = false;
    isRefundable: boolean = false;
    isDeleted: boolean = false;
    groupTicketDetailsProperties: GroupTicketDetailsProperties[];
  groupTicketSegmentsProperties: GroupTicketSegmentsProperties[];
  fareOnCall: boolean = false;
}
export class GroupTicketDetailsProperties {
    detailsId: number = 0;
    groupRelationId: number = 0;
    passengerType: number;
    baseFare: number;
    taxesAndOtherCharges: number;
    totalbaggageCharges: number = 0;
    baggageCheckIn: string = "";
    baggageCabin: string;
    totalMealCharges: number = 0;
    totalSeatCharges: number = 0;
    serviceCharges: number = 0;
    markup: number = 0;
    totalNetPrice: number = 0;
    totalGrossPrice: number = 0;
    cancel_RefundFee: number = 0;
    changeFee: number = 0;
    isDeleted: boolean = false;
}
export class GroupTicketSegmentsProperties {
    segmentId: number = 0;
    groupRelationId: number = 0;
    departureSegment: boolean = false;
    returnSegment: boolean = false;
    segmentType: number = 0;
    fromAirport: string;
    toAirport: string;
    fromAirportName: string;
    toAirportName: string;
    fromCityName: string;
    toCityName: string;
    rbd: string[] = [];
    cabinClass: string;
    operatingAirlineCode: string = "";
    validatingAirlineCode: string = "";
    flightNo: string;
    airlineName: string;
    airlineLogo: string;
    airlineCombineCode: string;
    departureDate: Date;
    departureTime: string;
    arrivalDate: Date;
    arrivalTime: string;
    fareBasisCode: string = "";
    aircraft: string;
    departureTerminal: string = "";
    arrivalTerminal: string = "";
    seatNo: string = "";
    meal: string = "";
    isDelete: boolean;
    timeElapsed: string = "";
}
export class SegmentTypeList {
    segmentTypeId: number;
    segmentTypeName: string;
}
export class PassengerTypeList {
    passengerTypeId: number;
    passengerTypeName: string;
}
export class TicketResponseMessage {
    status: boolean;
    message: string;
    responseData: any;
    soldTickets: number;
}
export class RBDTypeList {
    rbdType: string;
}
export class CabinClassList {
    cabinType: string;
}
export class TicketCurrencyProperties {
    currencyId: number;
    currencyName: string;
}
export class TicketSuppliersProperties {
    supplierId: string;
    supplierName: string;

}
export class GroupTicketBaseData {
    ticketCurrencyProperties: TicketCurrencyProperties[];
    ticketSuppliersProperties: TicketSuppliersProperties[];
}
export class TicketSuppliersAccessCodeProperties {
    codeId: number;
    CurrencyId: number;
    currencyName: string;
    supplierId: string;
    officeId: string;
    iataCode: string;
}

export class GroupTicketSearchParameters {
    departureDate: Date = null;
    oneWayFrom: string = null;
    oneWayTo: string = null;
    returnDate: Date = null;
    returnFrom: string = null;
    returnTo: string = null;
    isAdult: boolean = null;
    isChild: boolean = null;
    isInfant: boolean = null;
}

export class BookingPassengerInfo {
  passengerID: bigint;
  title: string = '';
  firstName: string = '';
  lastName: string = '';
  passengerType: number = 0;
  ticketNo: string = '';
  tktBookingDate: Date | null = null;
  travelingDate: Date | null = null;
  sector: string = '';
  supplierCode: string = '';
  airlineCode: string = '';
  tripType: string = '';
  paxGender: string = '';
  paxDOB: Date | null = null;
  paxNationality: string = '';
  passengerEmail: string = '';
  mobile: string = '';
  groupTicketId: bigint;

  //bookingPccCode: string = '';
  //sellerID: string = '';
  //buyerID: string = '';
  //serviceType: number = 0;
  //serviceSubType: number = 0;
  //pnrDoc: string = '';
  //iataCode: bigint | null = null;
  //conjOption: boolean = false;
  //conjTktNo: string = '';
  //exchangeTktNo: string = '';
  //exchangeOption: boolean = false;
  //exchangeTktFee: number = 0;
  //debitStatus: number = 0;
  //paymentMode: number = 0;
  //bookingID: bigint | null = null;
  //issuanceId: string = '';
  //issuancePccCode: string = '';
  //itineraryNo: string = '';
  //iataInvoiceNo: string = '';
  //mainSupplierID: string = '';
  //costFromAmount: number = 0;
  //costFromCurrency: number = 0;
  //costExchangeRate: number = 0;
  //baseCurrency: string = '';
  //exchangeCurrency: string = '';
  //baseFare: number = 0;
  //totalTaxes: number = 0;
  //markup: number = 0;
  //netFromCustomer: number = 0;
  //netToSupplier: number = 0;
  //region: string = '';
  //bookingInfoID: bigint | null = null;
  //paxIsLead: boolean = false;
  //passportNumber: string = '';
  //passportValidFrom: Date | null = null;
  //passportValidTo: Date = new Date();
  //modifiedDateTime: Date = new Date();
  //supplierRemarks: string = '';
  //isVoid: boolean = false;
  //airlineVoidCharges: number = 0;
  //agentVoidCharges: number = 0;
  //reasonForVoid: string = '';
  //venderServiceCharges: number = 0;
  //supplierCommission: number = 0;
  //supplierVatInput: number = 0;
  //customerVatInput: number = 0;
  //vatInput: number = 0;
  //customerVatOutput: number = 0;
  //supplierVatOutput: number = 0;
  //vatOutput: number = 0;
  //serviceCharges: number = 0;
  //discount: number = 0;
  //additionalServiceCharges: number = 0;
  //modifyAdditionalServiceCharges: number = 0;
  //commissionOffer: number = 0;
  //profit: number = 0;
  //visaApplicationNumber: string = '';
  //roundingDiff: number = 0;
  //originDestinationDetails: string = '';
  //runtimeMarkup: number = 0;
  //refundAmount: number = 0;
  //refundServiceCharges: number = 0;
  //netRefundAmount: number = 0;
  //isOfflineRefund: boolean = false;
  //isOfflineVoid: boolean = false;
  //isRefund: boolean = false;
  //agencyBranch: string = '';
  //currencySupplier: string = '';
  //supplierAmount: number = 0;
  //currencyAgency: string = '';
  //agencyAmount: number = 0;
  //isDeleted: boolean = false;
  //associatedAdult: string = '';
  //backSystemSupplierServiceId: bigint;
  //backSystemCustomerServiceId: bigint;
  //backSystemCustomerCompanyId: number;
  //additionalServiceChargesCurrencyRate: number;
  //ebm: string = '';
  //supplierBaseFare: number = 0;
  //supplierTotalTaxes: number = 0;
  //commissionForSupplier: number = 0;
  //netToSupplierRefund: number = 0;
  //exchangeInstanceID: string = '';
  //countyOfIssuance: string = '';
  //netRefundAmountCustomer: number = 0;
  //refundServiceChargesCustomer: number = 0;
  //refundAmountCustomer: number = 0;
  //refundPenalty: number = 0;
  //refundPenaltyCustomer: number = 0;
  //netToSupplierRefundCustomer: number = 0;
  //bookingStatusPassenger: number = 0;
}
